import { recoRoutes } from "@/modules/reco/routes";
import { sklRoutes } from "@/modules/skl/routes";
import { storyboardsRoutes } from "@/modules/storyboards/routes";
import { templatesRoutes } from "@/modules/templates/routes";
import { useAppStore } from "@/store/app";

const routeBaseName = "content";

export const contentRouteBasePath = `${routeBaseName}`;

export const contentRoutesNames = {
  root: routeBaseName,
  lists: {
    root: `${routeBaseName}.lists`,
    writtenContent: () => `${contentRoutesNames.lists.root}.written`,
    skl: () => `${contentRoutesNames.lists.root}.skl`,
    templates: () => `${contentRoutesNames.lists.root}.rich`,
    storyboards: () => `${contentRoutesNames.lists.root}.storyboards`,
    basicContent: () => `${contentRoutesNames.lists.root}.basic`,
    reco: () => `${contentRoutesNames.lists.root}.reco`,
  },
};

export const contentTabs = [
  {
    path: "written",
    name: contentRoutesNames.lists.writtenContent(),
    component: () => import("@/modules/content/views/ContentLists.vue"),
    meta: {
      tab: "wc",
      auth: true,
      scope: "contents:written_content:read",
      label: "BWCs",
    },
  },
  {
    path: "skl",
    name: contentRoutesNames.lists.skl(),
    component: () => import("@/modules/content/views/ContentLists.vue"),
    meta: {
      tab: "skl",
      auth: true,
      scope: "contents:skl:read",
      label: "SKLs",
    },
  },
  {
    path: "reco",
    name: contentRoutesNames.lists.reco(),
    component: () => import("@/modules/content/views/ContentLists.vue"),
    meta: {
      tab: "reco",
      auth: true,
      scope: "contents:reco:read",
      label: "RECOs",
    },
  },

  {
    path: "rich",
    name: contentRoutesNames.lists.templates(),
    component: () => import("@/modules/content/views/ContentLists.vue"),
    meta: {
      tab: "rich",
      auth: true,
      scope: "contents:rich:read",
      label: "Rich",
    },
  },
  {
    path: "storyboards",
    name: contentRoutesNames.lists.storyboards(),
    component: () => import("@/modules/content/views/ContentLists.vue"),
    meta: {
      tab: "cm",
      auth: true,
      scope: "contents:storyboards:read",
      label: "CMs",
    },
  },
];

const defaultContentTab = () => {
  const store = useAppStore();
  const tab = contentTabs.find((tab) => {
    const scope = tab.meta?.scope;
    return scope && store.auth(scope);
  });
  return tab ? { name: tab?.name } : false;
};

export const contentRoutes: any = [
  {
    path: contentRouteBasePath,
    name: contentRoutesNames.root,
    component: () => import("@/modules/content/views/layouts/Default.vue"),
    meta: {
      scrollTop: true,
    },
    children: [
      {
        path: "",
        name: contentRoutesNames.lists.root,
        component: () => import("@/modules/content/views/ContentLists.vue"),
        meta: {
          tab: "list",
        },
        redirect: () => defaultContentTab(),
        children: [...contentTabs],
      },
    ],
  },
  { ...sklRoutes(contentRouteBasePath) },
  ...storyboardsRoutes(contentRouteBasePath),
  ...templatesRoutes(contentRouteBasePath),
  { ...recoRoutes(contentRouteBasePath) },
];
